import { useAnimation } from 'hooks/useAnimation';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectGeneralIsLoading } from 'store/slices/GeneralSlice';

const PostFilter = ({ tags, selectedTag, onClick }) => {

    const isLoading = useSelector(selectGeneralIsLoading);

    const container = useRef();
    useAnimation({
        items: ['.blog-filter'],
        container,
        dependencies: [isLoading],
    })
    const TagItem = ({ tag }) => {
        const handleChange = () => onClick(tag);

        return (
            <button onClick={handleChange} className={`blog__tag-button link ${tag === selectedTag ? 'active' : ''}`}>
                {tag}
            </button>
        );
    };


    return (
        <div ref={container}>
            <div className="blog-filter">
                {tags.map(tag => (
                    <TagItem key={tag} tag={tag} />
                ))}
            </div>
        </div>
    );
};

export default PostFilter;
